import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const BreadcrumbHome = () => (_jsxs("svg", Object.assign({ viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg" }, { children: [_jsx("path", { d: "m9.5 36.72v22.5h15v-15h15v15h15v-22.5l-22.5-16.87z" }), _jsx("path", { d: "m32 4.78-30 23.29v9.49l30-23.28 30 23.28v-9.49z" })] })));
BreadcrumbHome.iconName = "breadcrumbhome";
BreadcrumbHome.iconCategory = "Misc - Deprecated";
BreadcrumbHome.deprecated = true;
export default BreadcrumbHome;
